import React from "react";
import { inject, observer } from "mobx-react";
import DJILogo from "./logo";


import "./stylesheets/index.scss";


const FOOTER_CN = {
  whoWeAre: {
    text: "RoboMaster",
    url: "https://www.robomaster.com/zh-CN?djifrom=ranking_footer",
  },
  contactUs: {
    text: "联系我们",
    url: " https://www.robomaster.com/zh-CN/contact?djifrom=ranking_footer",
  },
  careers: {
    text: "加入我们",
    url: "https://www.robomaster.com/zh-CN/recruit?djifrom=ranking_footer",
  },
  copyright:
    "Copyright © 2022 深圳市大疆无人机应用有限公司 版权所有备案号 粤ICP备2022092332号",
  privacyPolicy: {
    text: "隐私政策",
    url: "https://www.robomaster.com/zh-CN/privacy",
  },
};

const FOOTER_EN = {
  whoWeAre: {
    text: "RoboMaster",
    url: "https://www.robomaster.com/en-US",
  },
  contactUs: {
    text: "CONTACT US",
    url: "https://www.robomaster.com/en-US/contact",
  },
  copyright:
    "Copyright © 2023 DJI All Rights Reserved.",
  privacyPolicy: {
    text: "PRIVACY POLICY",
    url: "https://www.robomaster.com/en-US/privacy",
  },
  cookie: {
    text: "COOKIE PREFERENCES",
  }
};

@inject("languageStore")
@observer
class Footer extends React.Component {
  render() {
    const lang = this.props.languageStore.lang
    const content = lang === "en" ? FOOTER_EN : FOOTER_CN
    return (
      <div className="app-footer-box">
        <div className="app-footer">
          <div className="app-footer-main">
            <div className="app-footer-main__logo">
              <DJILogo />
            </div>
            <a
              href={content.whoWeAre.url}
              target="_black"
              className="app-footer-main__info"
            >
              {content.whoWeAre.text}
            </a>
            <a
              href={content.contactUs.url}
              target="_black"
              className="app-footer-main__info"
            >
              {content.contactUs.text}
            </a>
            {
              content.careers &&
              <a
                href={content.careers.url}
                target="_black"
                className="app-footer-main__info"
              >
                {content.careers.text}
              </a>
            }
            {
              content.cookie &&
              <div
                className="app-footer-main__info cc-consent-prefernces"
              >
                {content.cookie.text}
              </div>
            }
          </div>
          <div className="app-footer-main__gap" />
          <div className="app-footer-other">
            <div className="app-footer-other__text app-footer-other__text-copyright">
              {content.copyright}
            </div>
            <a
              href={content.privacyPolicy.url}
              target="_black"
              className="app-footer-other__text app-footer-other__text-a"
            >
              {content.privacyPolicy.text}
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/index.js